import { LanguageSelect } from "~/modules/dashboard/components/LanguageSelect";
import { RmorLogo } from "~/ui/logo/RmorLogo";
import { ReconizerLogo } from "~/ui/logo/ReconizerLogo";
import { Outlet } from "@remix-run/react";
import * as React from "react";

export default function PublicPage() {
  return (
    <div className="flex min-h-full items-center justify-center scrollbar-thin scrollbar-track-transparent scrollbar-thumb-secondary-50 scrollbar-thumb-rounded-full">
      <div className="absolute right-10 top-10">
        <LanguageSelect />
      </div>
      <div className="flex h-screen w-full max-w-md flex-col gap-6 px-6 pb-10 pt-16">
        <div className="flex items-center justify-center">
          <RmorLogo variant="white" />
        </div>
        <div className="my-auto">
          <ReconizerLogo />
          <Outlet />
        </div>
      </div>
    </div>
  );
}
